// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main {
  background: #fff;
  position: relative;
  z-index: 3;
}

.main-raised {
  margin: -15px 30px 20px;
  border-radius: 6px;
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14),
    0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
}

section {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("https://images.unsplash.com/photo-1517694712202-14dd9538aa97?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D");
  background-size: cover;
  background-position: center 80%;
}

.profile-img {
  max-width: 160px;
  transform: translate3d(0, -50%, 0);
}

.img-raised {
  box-shadow: 0 5px 15px -8px rgba(0, 0, 0, 0.24),
    0 8px 10px -5px rgba(0, 0, 0, 0.2);
}

.description {
  margin: auto;
  max-width: 600px;
  color: #999;
  font-weight: 300;
}

.icon {
  margin: 0.5em;
}

.profile-sideview {
  background-color: #edeaef;
  border-radius: 30px;
  padding-bottom: 10px;
}

.profile-pic {
  width: 150px;
  height: 150px;
  object-fit: cover; /* This property ensures the image covers the entire container while maintaining aspect ratio */
}

.row {
  max-width: 100vw;
}

.card .img-fit {
  aspect-ratio: 16 / 9;
  object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB;0EACwE;AAC1E;;AAEA;EACE;iLAC+K;EAC/K,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAKhB,kCAAkC;AACpC;;AAEA;EACE;sCACoC;AACtC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB,EAAE,+FAA+F;AACpH;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB","sourcesContent":[".App {\n  text-align: center;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.main {\n  background: #fff;\n  position: relative;\n  z-index: 3;\n}\n\n.main-raised {\n  margin: -15px 30px 20px;\n  border-radius: 6px;\n  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14),\n    0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);\n}\n\nsection {\n  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),\n    url(\"https://images.unsplash.com/photo-1517694712202-14dd9538aa97?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D\");\n  background-size: cover;\n  background-position: center 80%;\n}\n\n.profile-img {\n  max-width: 160px;\n  -webkit-transform: translate3d(0, -50%, 0);\n  -moz-transform: translate3d(0, -50%, 0);\n  -o-transform: translate3d(0, -50%, 0);\n  -ms-transform: translate3d(0, -50%, 0);\n  transform: translate3d(0, -50%, 0);\n}\n\n.img-raised {\n  box-shadow: 0 5px 15px -8px rgba(0, 0, 0, 0.24),\n    0 8px 10px -5px rgba(0, 0, 0, 0.2);\n}\n\n.description {\n  margin: auto;\n  max-width: 600px;\n  color: #999;\n  font-weight: 300;\n}\n\n.icon {\n  margin: 0.5em;\n}\n\n.profile-sideview {\n  background-color: #edeaef;\n  border-radius: 30px;\n  padding-bottom: 10px;\n}\n\n.profile-pic {\n  width: 150px;\n  height: 150px;\n  object-fit: cover; /* This property ensures the image covers the entire container while maintaining aspect ratio */\n}\n\n.row {\n  max-width: 100vw;\n}\n\n.card .img-fit {\n  aspect-ratio: 16 / 9;\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
